import TemplateView from "../../../TemplateView";
import StatusFilterButton from "../../tasksTable/StatusFilterButton";
import MinimizeKanbanViewCardsButton from "./MinimizeKanbanViewCardsButton";
import {getInstance as getWorkflowStatusFilterMenu} from "../../../workflowStatus/components/statusFilter/TaskWorkflowStatusFilterMenu"
import SelectAllButton from './SelectAllButton'
import CollapseAllButton from './CollapseAllButton'


export default class KanbanFiltersPanel extends TemplateView {
    constructor({
        onAllSelectedChanged = selectAll => {},
        onStatusFilterChanged = statusFilter => {},
        onMinimizedCardsChanged = minimized => {},
        onCollapseAllChanged = isAllCollapsed => {}
    }) {
        super()

        this.callbacks = {
            onAllSelectedChanged,
            onStatusFilterChanged,
            onMinimizedCardsChanged,
            onCollapseAllChanged,
        }

        this.state = {
            allTasksSelected: false,
            collapsedProjects: {
                all: false,
                idsSet: {},
            },
            taskStatusFilter: {
                allSelected: true,
                statusIds: [],
                statusTypes: [],
            },
            singleCPSelection: {},
            workflowStatusesMap: {},
            minimizedCards: false,
            showSelection: false,
            ignoreProjectCollapse: false,
        }

        this.onStatePropertyChanged('collapsedProjects', (collapsedProjects) => {
            this.collapseAllButton.setState({
                isAllCollapsed: collapsedProjects.all,
            })
        })

        this.onStatePropertyChanged('ignoreProjectCollapse', (ignoreProjectCollapse) => {
            this.collapseAllButton.setState({
                disableCollapse: ignoreProjectCollapse,
            })
        })

        this.onStatePropertyChanged('allTasksSelected', (allTasksSelected) => {
            this.selectAllButton.setState({
                isAllSelected: allTasksSelected,
            })
        })

        this.onStatePropertyChanged('workflowStatusesMap', (workflowStatusesMap) => {
            this.filterButton.setState({
                workflowStatusesMap: workflowStatusesMap,
            })
        })

        this.onStatePropertyChanged('taskStatusFilter', (filter) => {
            this.filterButton.setState({
                filter: filter,
            });
        })
        this.onStatePropertyChanged("minimizedCards", (minimizedCards) => {
            this.minimizeButton.setState({minimizedCards})
        });

        this.onStatePropertyChanged('singleCPSelection', singleCPSelection => {
            const notSingleProjectSelection = !singleCPSelection.customerId || !singleCPSelection.projectId
            this.$collapseAllButtonContainer
                .toggle(notSingleProjectSelection)
                .next('.separator').toggle(notSingleProjectSelection)
        })

        this.onStatePropertyChanged("showSelection", showSelection => {
            this.$selectAllButtonContainer
                .toggle(showSelection)
                .next('.separator').toggle(showSelection)
        })
    }

    templateHtml() {
        return "<div class='kanbanView_components_filtersPanel'>" +
               "  <div class='workflowStatusesLabel'><%-workflowStatusesLabel%></div>" +
               "  <div class='workflowStatusesFilterContainer'></div>" +
               "  <div class='separator'></div>" +
               "  <div class='selectAllButtonContainer'></div>" +
               "  <div class='separator'></div>" +
               "  <div class='collapseAllButtonContainer'></div>" +
               "  <div class='separator'></div>" +
               "  <div class='minimizedCardsLabel'><%-cardsViewLabel%></div>" +
               "  <div class='minimizedCardsSelectorContainer'></div>" +
               "  <div class='separator'></div>" +
               "</div>"
    }

    afterRender() {
        this.$selectAllButtonContainer = this.find('.selectAllButtonContainer')

        this.selectAllButton = new SelectAllButton({
            onSelectAllCallback: (isAllSelected) => {
                if (this.state.showSelection) this.callbacks.onAllSelectedChanged(isAllSelected)
            },
        }).init(this.$selectAllButtonContainer)

        this.$collapseAllButtonContainer = this.find('.collapseAllButtonContainer')
        this.collapseAllButton = new CollapseAllButton({
            onCollapseAllCallback: this.callbacks.onCollapseAllChanged,
        }).init(this.$collapseAllButtonContainer)

        this.filterButton = new StatusFilterButton({
            getStatusMenu: () => getWorkflowStatusFilterMenu(),
        }).init(this.find(".workflowStatusesFilterContainer"));
        this.minimizeButton = new MinimizeKanbanViewCardsButton(null, {
            onClick: () => {this.callbacks.onMinimizedCardsChanged(!this.state.minimizedCards)}
        }).init(this.find(".minimizedCardsSelectorContainer"));

        this.renderInitialState()
    }

    messageKeys() {
        return {
            workflowStatusesLabel: "task.list.kanban.workflow_statuses",
            cardsViewLabel: "task.list.kanban.cards_view"
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/KanbanFiltersPanel.js